import React, { useEffect, useState, useRef } from "react";
import {
  AddCircleOutline,
  Delete,
  Edit,
  Visibility
} from "@mui/icons-material";
import { Button, IconButton, Switch, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import EmployerViewController from "../../redux/actions/EmployerApiAction";
import EmployerFormModal from "./AddEmployer";
import "../../styles/styles.css";
import "../../styles/layout.css";
import { Form } from "react-bootstrap";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import EmployerViewModal from "./EmployerViewModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExportButton from "../../components/ag grid/ExportButton";

const EmployerList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editEmployer, setEditEmployer] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedEmployer, setSelectedEmployer] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployers, setFilteredEmployers] = useState([]);

  const { getEmployer, deleteEmployer, updateEmployer } =
    EmployerViewController();
  const { employers } = useSelector((state) => state.employer);

  useEffect(() => {
    dispatch(getEmployer());
  }, []);

  const handleDelete = (id) => dispatch(deleteEmployer(id));
  const handleEdit = (employer) => {
    setEditEmployer(employer);
    setShowModal(true);
  };
  const handleView = (employer) => {
    setSelectedEmployer(employer);
    setViewModalOpen(true);
  };
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "Sr. No.",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 70
    },
    {
      headerName: "Name",
      valueGetter: (params) =>
        `${params.data.first_name || ""} ${params.data.last_name || ""}`,
      flex: 1
    },
    {
      headerName: "Company",
      field: "company.company_name",
      flex: 1
    },
    {
      headerName: "Email",
      field: "email",
      flex: 1
    },
    {
      headerName: "Phone",
      field: "mobile_number",
      flex: 1
    },
    {
      headerName: "Active",
      field: "is_active",
      flex: 0.5,
      cellRenderer: (params) => {
        const handleChange = (e) => {
          const updatedValue = e.target.checked;
          const updatedData = {
            ...params.data,
            is_active: updatedValue,
            company: params.data.company.id,
          };

          // Update grid UI immediately
          params.node.setDataValue("is_active", updatedValue);

          // Dispatch API call
          dispatch(updateEmployer(params.data.id, updatedData))
            .then(() => {
              console.log("Employer status updated");
            })
            .catch((err) => {
              console.error("Failed to update status", err);
            });
        };

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Switch
              checked={params.value}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </div>
        );
      }
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 160,
      maxWidth: 180,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <div>
      <div className="d-flex  flex-wrap mb-3" style={{ gap: "12px", alignItems: "center" }}>
  {/* Add Employer Button */}
 
    <Button
      variant="contained"
      startIcon={<AddCircleOutline />}
      onClick={() => {
        setEditEmployer(null);
        setShowModal(true);
      }}
      sx={{
        borderRadius: "8px",
        backgroundColor: "#1976d2",
        textTransform: "none",
        paddingX: 2,
        height: "40px",
        fontSize: "0.875rem",
      }}
    >
      Add Employer
    </Button>
  

  {/* Export Button */}
 
    <ExportButton
      gridRef={gridRef}
      fileName="EmployerList.xlsx"
      exportColumns={[
        "first_name",
        "last_name",
        "email",
        "mobile_number",
        "is_active"
      ]}
      disabled={selectedRows.length === 0}
    />
  

  {/* Search Bar */}
  <div style={{ flexGrow: 1 }}>
   <Form.Control
  type="text"
  placeholder="Search employer..."
  style={{ height: "40px" }}
  value={searchTerm}
  onChange={(e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const lowercasedValue = value.toLowerCase();
    const filtered = employers.filter((emp) => {
      const fullName = `${emp.first_name} ${emp.last_name}`.toLowerCase();
      const email = emp.email?.toLowerCase();
      return fullName.includes(lowercasedValue) || email.includes(lowercasedValue);
    });

    setFilteredEmployers(filtered); // ✅ Always update filteredEmployers

    // ✅ Only update grid if it's ready
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setRowData(filtered);
    }
  }}
/>

  </div>

  {/* Page Size Selector */}
  <PageSizeSelector
    pageSize={pageSize}
    onChange={(e) => setPageSize(Number(e.target.value))}
  />
</div>

      {/* <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Employer List</h3>
          </Col>
        </Row>
      </div> */}

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={searchTerm ? filteredEmployers : employers}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <EmployerFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editEmployer}
      />
      <EmployerViewModal
        show={viewModalOpen}
        handleClose={() => setViewModalOpen(false)}
        employer={selectedEmployer}
      />
    </div>
  );
};

export default EmployerList;
